import { render, staticRenderFns } from "./CircledArrow.vue?vue&type=template&id=6a255882&"
import script from "./CircledArrow.vue?vue&type=script&lang=ts&"
export * from "./CircledArrow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports